import React, { useEffect, useMemo, useState } from "react";
import { Alert, DatePicker, Form, Modal } from "antd";
import dayjs from "dayjs";
import { formatDateTime, toApiDateTime } from "./doc-exp-utils";

const mergeDateKeepTime = (datePart, planned) => {
  const d = dayjs(datePart);
  const p = planned && dayjs(planned).isValid() ? dayjs(planned) : d;
  if (!d.isValid()) return null;
  return d.hour(p.hour()).minute(p.minute()).second(p.second()).millisecond(0);
};

/**
 * Диалог заселения / выселения одной путёвки.
 * Delphi: TFrmActViezd (плановая и фактическая дата).
 */
const DocExpLifecycleModal = ({ open, mode, row, onCancel, onOk }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const isCheckIn = mode === "check-in";
  const planned = isCheckIn ? row?.dateBeg : row?.dateEnd;
  const factWatch = Form.useWatch("dateFact", form);
  const stayChanged = useMemo(() => {
    if (!planned || !factWatch) return false;
    return !dayjs(factWatch).isSame(dayjs(planned), "day");
  }, [planned, factWatch]);

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({ dateFact: planned ? dayjs(planned) : dayjs() });
  }, [open, planned, form]);

  const title = isCheckIn ? "Заселение" : "Выселение";

  const submit = async () => {
    const values = await form.validateFields();
    const fact = mergeDateKeepTime(values.dateFact, planned);
    if (!fact) return;
    if (isCheckIn && planned && fact.isBefore(dayjs(planned), "day")) {
      form.setFields([{ name: "dateFact", errors: ["Нельзя оформить заезд раньше плана"] }]);
      return;
    }
    if (!isCheckIn && planned && fact.isAfter(dayjs(planned), "day")) {
      form.setFields([{ name: "dateFact", errors: ["Нельзя оформить выезд позже плана"] }]);
      return;
    }
    setSubmitting(true);
    try {
      await onOk(toApiDateTime(fact));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={submit}
      okText="ОК"
      cancelText="Отмена"
      confirmLoading={submitting}
      destroyOnHidden
    >
      <p style={{ marginTop: 0 }}>
        Путёвка №{row?.docnum || row?.idDoc}
      </p>
      <Form form={form} layout="vertical">
        <Form.Item label="Плановая дата / время">
          <div>{formatDateTime(planned) || "—"}</div>
        </Form.Item>
        <Form.Item
          name="dateFact"
          label="Фактическая дата"
          rules={[{ required: true, message: "Укажите дату" }]}
        >
          <DatePicker format="DD.MM.YYYY" allowClear={false} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
      {stayChanged ? (
        <Alert type="warning" showIcon message="Срок пребывания изменён" />
      ) : null}
      {!isCheckIn &&
      (Math.abs(Number(row?.symaDolg) || 0) > 0.005 ||
        Math.abs(Number(row?.avansOpen) || 0) > 0.005) ? (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 12 }}
          message="Есть долг или неразнесённый аванс. Выселение возможно только после оплаты услуг и зачёта аванса."
        />
      ) : null}
    </Modal>
  );
};

export default DocExpLifecycleModal;
